import { GeoCoordinates } from '@sc/data-access-models';

export interface MapOnBoundsChangeEvent {
  bounds: google.maps.LatLngBounds;
  isAuto: boolean;
}

export interface MapOnCenterChangeEvent {
  center: GeoCoordinates;
  isAuto: boolean;
}

export interface MapOnZoomChangeEvent {
  zoom: number;
  isAuto: boolean;
}
